export default __webpack_public_path__ + "6c0668ad16302d8d7f26bd4b5d4392d7.png";